// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"347":"lang-nl-json","740":"jsvat","752":"libphonenumber"}[chunkId] + "." + {"347":"6d9d2018722ecc752117","740":"744dc1eefa860bbf1f8c","752":"f286d8103c483c5026d0"}[chunkId] + ".js";
};